import { resetRegistration } from 'store/register/actions';
import { createReducer } from '@reduxjs/toolkit';

import * as actions from './actions';
import { RegisterState, InsuranceType } from './types';

export const initialState: RegisterState = {
  isSubmitting: false,
  currentStep: 'insurance',
  error: null,
  alert: {
    severity: undefined,
    title: undefined,
    message: undefined
  },
  data: {
    firstName: '',
    lastName: '',
    dateOfBirth: null,
    shSubscriberNumber: null,
    pharmacyPlanId: null,
    medicaidId: null,
    gender: '',
    ethnicity: '',
    streetAddress: '',
    unitNumber: '',
    city: '',
    state: '',
    zip: '',
    country: '',
    phone: '',
    email: '',
    username: '',
    password: '',
    ssn: '',
    registrationStatus: '',
    termsAcceptance: null
  },
  meta: {
    insuranceType: InsuranceType.NONE,
    insuranceId: ''
  },
  mobileRegistrationSession: false,
  accountCreationInfo: false
};

const registration = createReducer(initialState, {
  [actions.CREATE_ACCOUNT]: state => {
    state.isSubmitting = true;
    state.error = null;
  },
  [actions.CREATE_ACCOUNT_SUCCESS]: state => {
    if (state) state.isSubmitting = false;
  },
  [actions.CREATE_ACCOUNT_FAIL]: (state, action) => {
    state.isSubmitting = false;
    state.error = action.error;
  },
  [actions.UPDATE_STEP]: (state, action) => {
    state.currentStep = action.payload;
  },
  [actions.UPDATE_ALERT]: (state, action) => {
    state.alert = action.payload;
  },
  [actions.UPDATE_DATA]: (state, action) => {
    const newData = {
      ...state.data,
      ...action.payload
    };

    if (action.payload.phone) {
      newData.phone = action.payload.phone.replace(/\D/g, '');
    }

    state.data = newData;
  },
  [actions.UPDATE_META]: (state, action) => {
    state.meta = {
      ...state.meta,
      ...action.payload
    };
  },
  [actions.VALIDATE_CONSUMER_HEALTH_IDS]: state => {
    state.isSubmitting = true;
    state.error = null;
  },
  [actions.VALIDATE_CONSUMER_HEALTH_IDS_SUCCESS]: (state, action) => {
    state.isSubmitting = false;
    state.data = {
      ...state.data,
      consumerId: action.payload.data.consumerId
    };
  },
  [actions.VALIDATE_CONSUMER_HEALTH_IDS_FAIL]: (state, action) => {
    state.isSubmitting = false;
    state.error = action.error;
  },
  [actions.SEND_VERIFICATION_CODE]: state => {
    state.error = null;
  },
  [actions.SEND_VERIFICATION_CODE_SUCCESS]: state => {
    // Handle success?
  },
  [actions.SEND_VERIFICATION_CODE_FAIL]: (state, action) => {
    state.error = action.error;
  },
  [actions.VALIDATE_VERIFICATION_CODE]: state => {
    state.isSubmitting = true;
    state.error = null;
  },
  [actions.VALIDATE_VERIFICATION_CODE_SUCCESS]: state => {
    if (state) state.isSubmitting = false;
  },
  [actions.VALIDATE_VERIFICATION_CODE_FAIL]: (state, action) => {
    state.isSubmitting = false;
    state.error = action.error;
  },
  [actions.VERIFY_PERSON]: state => {
    state.isSubmitting = true;
    state.error = null;
  },
  [actions.VERIFY_PERSON_SUCCESS]: state => {
    if (state) state.isSubmitting = false;
  },
  [actions.VERIFY_PERSON_FAIL]: (state, action) => {
    state.isSubmitting = false;
    state.error = action.error;
  },
  [actions.VERIFY_SOCIAL]: state => {
    state.isSubmitting = true;
    state.error = null;
  },
  [actions.VERIFY_SOCIAL_SUCCESS]: state => {
    if (state) state.isSubmitting = false;
  },
  [actions.VERIFY_SOCIAL_FAIL]: (state, action) => {
    state.isSubmitting = false;
    state.error = action.error;
  },
  [actions.UPDATE_REGISTRATION_SESSION]: (state, action) => {
    state.mobileRegistrationSession = action.payload;
  },
  [actions.GET_REDIRECT_URL]: state => {
    state.isSubmitting = true;
    state.error = null;
  },
  [actions.GET_REDIRECT_URL_FAIL]: (state, action) => {
    state.isSubmitting = false;
    state.error = action.error;
  },
  [actions.GET_REDIRECT_URL_SUCCESS]: state => {
    state.isSubmitting = false;
  },
  [actions.VALIDATE_CONSUMER_ID]: state => {
    state.isSubmitting = true;
    state.isAccountAlreadyExist = false;
    state.error = null;
  },
  [actions.VALIDATE_CONSUMER_ID_SUCCESS]: (state, action) => {
    state.isSubmitting = false;
    state.isAccountAlreadyExist = action.payload.data;
  },
  [actions.VALIDATE_CONSUMER_ID_FAIL]: (state, action) => {
    state.isSubmitting = false;
    state.isAccountAlreadyExist = false;
    state.error = action.error;
  },
  [actions.UPDATE_ACCOUNT_CREATION_INFO]: state => {
    state.accountCreationInfo = true;
  },
  [resetRegistration.type]: () => initialState
});

export default registration;
